export default {"src":"/_next/static/media/alert.ebeb4e05.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};